import React, { useState } from "react";
import { Collapse } from "reactstrap";
import { ActionMenu } from "../../Common/Components/Lists/SortableList";

/**
 * EconomicSettingsAccordion
 *
 * Collapsible card for one group of economic settings, styled like the
 * SortableList card table used in ReportProceedingList (sl-* classes).
 *
 * Props:
 *   title          string                        group title
 *   labelHeader    string                        header of the first column
 *   valueHeader    string                        header of the value column
 *   rows           [{ id, label, value }]        label/value can be nodes
 *   renderActions  (row, index) => node | null   buttons for the ⋯ menu (same markup as list action columns)
 *   defaultOpen    boolean
 *   toolbar        node                          optional content shown inside the body, above the table
 */
export const EconomicSettingsAccordion = ({ title, labelHeader, valueHeader, rows, renderActions, defaultOpen = false, toolbar = null }) => {
    const [open, setOpen] = useState(defaultOpen);

    const hasRows = Array.isArray(rows) && rows.length > 0;
    // Keep the card when it has a toolbar (e.g. "add" button), even without rows
    if (!hasRows && !toolbar) return null;

    return (
        <div className="sl-card-shell economic-accordion mb-3">
            <button
                type="button"
                className="economic-accordion-header"
                onClick={() => setOpen(prev => !prev)}
                aria-expanded={open}
            >
                <span className="economic-accordion-title">{title}</span>
                <i className={`bx ${open ? 'bx-caret-up' : 'bx-caret-down'} economic-accordion-icon`} />
            </button>

            <Collapse isOpen={open}>
                <div className="economic-accordion-body">
                {toolbar}
                {hasRows && (
                <table className="sl-table-layout economic-accordion-table">
                    <colgroup>
                        <col />
                        <col style={{ width: '30%' }} />
                        <col style={{ width: '64px' }} />
                    </colgroup>
                    <thead>
                        <tr>
                            <th className="sl-th-base economic-accordion-th">{labelHeader}</th>
                            <th className="sl-th-base economic-accordion-th economic-accordion-th-value">{valueHeader}</th>
                            <th className="sl-th-base economic-accordion-th" />
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((row, index) => {
                            const actions = renderActions ? renderActions(row, index) : null;
                            return (
                                <tr key={row.id} className={`sl-row ${index < rows.length - 1 ? 'sl-row-divider' : ''}`}>
                                    <td className="sl-td-base economic-accordion-td">{row.label}</td>
                                    <td className="sl-td-base economic-accordion-td economic-accordion-value">{row.value}</td>
                                    <td className="sl-td-base economic-accordion-td">
                                        {actions && (
                                            <div className="sl-td-action-wrap">
                                                <ActionMenu
                                                    item={row}
                                                    actionColumn={() => actions}
                                                    iconType="bx-dots-horizontal-rounded"
                                                />
                                            </div>
                                        )}
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
                )}
                </div>
            </Collapse>
        </div>
    );
};
